/* Megaloom theme */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* Cabecera: sombra al hacer scroll */
  function initHeader() {
    const header = $('.site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Cajón de menú móvil */
  function initDrawer() {
    $$('[data-drawer-open]').forEach((btn) => {
      const drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      const panel = $('.drawer__panel', drawer);
      const close = () => {
        drawer.classList.remove('is-open');
        document.body.classList.remove('has-drawer');
        btn.setAttribute('aria-expanded', 'false');
        setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 450);
        btn.focus();
      };
      const open = () => {
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        document.body.classList.add('has-drawer');
        btn.setAttribute('aria-expanded', 'true');
        const first = $('a, button, summary', panel);
        if (first) setTimeout(() => first.focus(), 60);
      };
      btn.addEventListener('click', open);
      $$('[data-drawer-close]', drawer).forEach((el) => el.addEventListener('click', close));
      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          const focusables = $$('a[href], button:not([disabled]), summary, input', panel).filter((el) => el.offsetParent !== null);
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    });
  }

  /* Buscador desplegable en la cabecera */
  function initSearchToggle() {
    $$('[data-search-toggle]').forEach((btn) => {
      const pop = document.getElementById(btn.getAttribute('aria-controls'));
      if (!pop) return;
      btn.addEventListener('click', () => {
        const open = pop.hidden;
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { const input = $('input', pop); if (input) input.focus(); }
      });
      pop.addEventListener('keydown', (e) => { if (e.key === 'Escape') { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); } });
    });
  }

  /* Barra de anuncios rotativa */
  function initAnnouncements() {
    $$('.announcement__track').forEach((track) => {
      const items = $$('.announcement__item', track);
      if (items.length < 2) return;
      let i = 0;
      const speed = (parseInt(track.dataset.speed, 10) || 5) * 1000;
      let timer = setInterval(next, speed);
      function next() {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      track.addEventListener('mouseenter', () => clearInterval(timer));
      track.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(next, speed); });
    });
  }

  /* Filtro rápido: atenúa lo que no coincide */
  function initQuickChips() {
    $$('[data-quick-chips]').forEach((wrap) => {
      const grid = document.getElementById(wrap.dataset.target);
      if (!grid) return;
      const chips = $$('.chip', wrap);
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const value = chip.dataset.value;
          const isActive = chip.getAttribute('aria-pressed') === 'true';
          chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
          const filter = isActive || value === '' ? '' : value;
          if (filter) chip.setAttribute('aria-pressed', 'true');
          else { const all = chips.find((c) => c.dataset.value === ''); if (all) all.setAttribute('aria-pressed', 'true'); }
          $$('li[data-type]', grid).forEach((li) => {
            li.classList.toggle('is-dimmed', !!filter && li.dataset.type !== filter);
          });
          grid.classList.remove('is-filtered');
          void grid.offsetWidth;
          grid.classList.add('is-filtered');
          const counter = grid.parentElement && $('.toolbar__count', grid.parentElement);
          if (counter) {
            const n = $$('li[data-type]:not(.is-dimmed)', grid).length;
            counter.textContent = n + (n === 1 ? ' producto' : ' productos');
          }
        });
      });
    });
  }

  /* Filtros de colección: enviar al cambiar */
  function initFacets() {
    const desktop = window.matchMedia('(min-width: 990px)');
    const syncPanels = () => $$('[data-facets-panel]').forEach((d) => { if (desktop.matches) d.open = true; });
    syncPanels();
    desktop.addEventListener('change', syncPanels);
    $$('form[data-facets]').forEach((form) => {
      form.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"], select')) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    $$('select[data-sort]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* Cantidad +/- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const input = $('input', btn.closest('.qty'));
      if (!input) return;
      const min = parseInt(input.min, 10) || 0;
      const current = parseInt(input.value, 10) || min;
      input.value = Math.max(min, current + (btn.dataset.qty === 'plus' ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Carrito: auto-actualizar cantidades */
  function initCart() {
    const form = $('form[data-cart-form]');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => form.submit(), 500);
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
    });
  }

  /* Producto: galería, variantes, añadir al carrito */
  function initProduct() {
    $$('[data-product]').forEach((root) => {
      const dataEl = $('script[data-product-json]', root);
      const product = dataEl ? JSON.parse(dataEl.textContent) : null;
      const form = $('form[data-product-form]', root);
      const idInput = form ? $('input[name="id"]', form) : null;
      const submit = form ? $('[type="submit"]', form) : null;
      const status = $('[data-buy-status]', root);
      const priceWrap = $('[data-price]', root);
      const mainImg = $('[data-main-media] img', root);

      /* miniaturas */
      $$('[data-thumb]', root).forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!mainImg) return;
          mainImg.src = btn.dataset.src;
          mainImg.srcset = btn.dataset.srcset || '';
          mainImg.alt = btn.dataset.alt || '';
          $$('[data-thumb]', root).forEach((b) => b.setAttribute('aria-current', 'false'));
          btn.setAttribute('aria-current', 'true');
        });
      });

      /* variantes */
      if (product && product.variants.length > 1) {
        root.addEventListener('change', (e) => {
          if (!e.target.matches('[data-option]')) return;
          const selected = $$('[data-option-group]', root).map((group) => {
            const checked = $('input:checked', group) || $('select', group);
            return checked ? checked.value : null;
          });
          $$('[data-option-group]', root).forEach((group, i) => {
            const labelValue = $('[data-selected-value]', group);
            if (labelValue) labelValue.textContent = selected[i];
          });
          const variant = product.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
          if (!variant) {
            if (submit) { submit.disabled = true; submit.querySelector('span').textContent = submit.dataset.unavailable; }
            return;
          }
          if (idInput) idInput.value = variant.id;
          if (submit) {
            submit.disabled = !variant.available;
            submit.querySelector('span').textContent = variant.available ? submit.dataset.add : submit.dataset.soldout;
          }
          if (priceWrap) {
            const now = $('[data-price-now]', priceWrap);
            const was = $('[data-price-was]', priceWrap);
            if (now) now.textContent = formatMoney(variant.price, priceWrap.dataset.format);
            if (was) {
              was.hidden = !(variant.compare_at_price > variant.price);
              was.textContent = formatMoney(variant.compare_at_price || 0, priceWrap.dataset.format);
            }
            priceWrap.classList.toggle('price--sale', variant.compare_at_price > variant.price);
          }
          if (variant.featured_image && mainImg) {
            mainImg.src = variant.featured_image.src;
            mainImg.removeAttribute('srcset');
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      /* al pulsar un color, mostrar la foto de ese color (busca por el texto alternativo de la imagen) */
      const stem = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[oa]s?$/, '');
      const thumbs = $$('[data-thumb]', root);
      if (thumbs.length > 1) {
        root.addEventListener('change', (e) => {
          if (!e.target.matches('[data-option]')) return;
          const wanted = stem(e.target.value);
          if (!wanted) return;
          const match = thumbs.find((btn) => (btn.dataset.alt || '').split(/[\s,.:;()-]+/).some((w) => stem(w) === wanted));
          if (match) match.click();
        });
      }

      /* añadir al carrito sin recargar, con envío normal como respaldo */
      if (form && window.fetch && form.dataset.ajax === 'true') {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!submit) return;
          const label = submit.querySelector('span');
          const original = label.textContent;
          submit.setAttribute('aria-busy', 'true');
          submit.disabled = true;
          label.textContent = window.strings.adding;
          if (status) { status.textContent = ''; status.className = 'buy-status'; }
          try {
            const res = await fetch(window.routes.cart_add_url + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.description || window.strings.error);
            const cart = await fetch(window.routes.cart_url + '.js').then((r) => r.json());
            updateCartCount(cart.item_count);
            if (status) {
              status.className = 'buy-status is-ok';
              status.innerHTML = window.strings.added + ' <a href="' + window.routes.cart_url + '">' + (status.dataset.viewCart || '') + '</a>';
            }
          } catch (err) {
            if (status) { status.className = 'buy-status is-error'; status.textContent = err.message || window.strings.error; }
          } finally {
            submit.removeAttribute('aria-busy');
            submit.disabled = false;
            label.textContent = original;
          }
        });
      }

      /* barra fija de compra en móvil */
      const sticky = $('[data-sticky-buy]', root);
      if (sticky && submit && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        io.observe(submit);
        const stickyBtn = $('button', sticky);
        if (stickyBtn) stickyBtn.addEventListener('click', () => submit.click());
      }
    });
  }

  function formatMoney(cents, format) {
    const value = (cents / 100);
    const fmt = format || '{{amount_with_comma_separator}} €';
    const withComma = value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDecimals = Math.round(value).toLocaleString('es-ES');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') return noDecimals;
      if (key === 'amount') return value.toLocaleString('en-US', { minimumFractionDigits: 2 });
      return withComma;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initDrawer();
    initSearchToggle();
    initAnnouncements();
    initQuickChips();
    initFacets();
    initQty();
    initCart();
    initProduct();
  });

  /* Reinicializar en el editor de temas al recargar secciones */
  document.addEventListener('shopify:section:load', () => {
    initAnnouncements();
    initQuickChips();
    initProduct();
  });
})();
